import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, EmptyState } from "@/components/app/Primitives";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs?limit=500").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-6">
      <Section title="Audit log" subtitle="Every action is captured with actor, tenant, entity and timestamp — used for compliance and L3 troubleshooting." />
      {logs.length === 0 ? <EmptyState title="No audit events yet" /> : (
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-widest text-slate-500">
              <tr>
                <th className="px-4 py-3 text-left">When</th>
                <th className="px-4 py-3 text-left">Actor</th>
                <th className="px-4 py-3 text-left">Role</th>
                <th className="px-4 py-3 text-left">Action</th>
                <th className="px-4 py-3 text-left">Entity</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t hover:bg-slate-50">
                  <td className="px-4 py-2 text-xs text-slate-500">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-4 py-2">{l.user_email}</td>
                  <td className="px-4 py-2 capitalize text-xs">{(l.user_role || "").replace(/_/g, " ")}</td>
                  <td className="px-4 py-2 font-mono text-xs">{l.action}</td>
                  <td className="px-4 py-2 text-xs">{l.entity_type} · <span className="font-mono">{l.entity_id?.slice(0, 8)}…</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
